'use client'

import { useState } from 'react'

import { OutageSplash } from '@src/components/OutageSplash/OutageSplash'
import { SocialLadderIframe } from '@src/components/SocialLadder/SocialLadderIframe'

interface Props {
  deviceUUID: string | null
}

export function SocialLadder({ deviceUUID }: Props) {
  const [isSplashed, setIsSplashed] = useState(false)

  if (isSplashed) return <OutageSplash />

  return (
    <SocialLadderIframe
      className="min-h-[50vh]"
      flow="ambassadorDashboard"
      deviceUUID={deviceUUID}
      onError={() => setIsSplashed(true)}
    />
  )
}
